"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPTION_ID = "wheel-picker-option-";
//# sourceMappingURL=optionID.js.map